interface EmptyStateProps {
	icon: string;
	title: string;
	description?: string;
}

export function EmptyState({ icon, title, description }: EmptyStateProps) {
	return (
		<div className="empty-state">
			<span className="empty-state__icon">{icon}</span>
			<h3 className="empty-state__title">{title}</h3>
			{description && <p className="empty-state__description">{description}</p>}
		</div>
	);
}
